import {
  Button,
  Checkbox,
  Col,
  DatePicker,
  Form,
  Input,
  Modal,
  Radio,
  Row,
  Select,
  Table,
  Tag,
  Tooltip,
} from "antd";
import moment from "moment";
import React, { useEffect, useState } from "react";
import "react-phone-input-2/lib/style.css";
import SectionWrapper from "../../components/SectionWrapper";
import apiPath from "../../constants/apiPath";
import { Severty, ShowToast } from "../../helper/toast";
import useRequest from "../../hooks/useRequest";
import EditIcon from "../../assets/images/edit.svg";
import lang from "../../helper/langHelper";
import DeleteModal from "../../components/DeleteModal";
import deleteWhiteIcon from "../../assets/images/icon/deleteWhiteIcon.png";

const targetAudience = [
  { name: "All", label: lang("All") },
  { name: "Selected", label: lang("Selected") },
];

const ViewNotificationModal = ({
  section,
  show,
  hide,
  data,
  sendingType = "create",
}) => {
  const [form] = Form.useForm();
  const { request } = useRequest();
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [pagination, setPagination] = useState({
    current: 1,
    total: 10,
  });
  const [showDelete, setShowDelete] = useState(false);
  const [selectedAddBanner, setSelectedAddBanner] = useState();
  const [refresh, setRefresh] = useState(false);

  const columns = [

    {
      title: lang("Title"),
      dataIndex: "title",
      key: "title",
      sorter: (a, b) => a?.title?.localeCompare(b?.title),
      sortDirections: ["ascend", "descend"],
      render: (_, { title }) => title,
    },
    {
      title: lang("notification type"),
      dataIndex: "notification_type",
      key: "notification_type",
      sorter: (a, b) => a?.notification_type?.localeCompare(b?.notification_type),
      sortDirections: ["ascend", "descend"],
      render: (_, { notification_type }) => notification_type,
    },  
    {
      title: lang("Notifications"),
      dataIndex: "message",
      key: "message",
      sorter: (a, b) => a?.message?.localeCompare(b?.message),
      sortDirections: ["ascend", "descend"],
      render: (_, { message }) => message,
    },   
    {
      title: lang("Target Audience"),
      dataIndex: "audience",
      key: "audience",
      sorter: (a, b) => a?.audience?.localeCompare(b?.audience),
      sortDirections: ["ascend", "descend"],
      render: (_, { audience }) => {
        return audience ? <span className="cap">{audience}</span> : "-";
      },
    },
    {
      title: lang("schedule time"),
      dataIndex: "schedule_time",
      key: "schedule_time",

      render: (_, { schedule_time }) => {
        return schedule_time ? <span className="cap">{moment(schedule_time).format("DD:MM:yy hh:mm a")}</span> : "-";
      },
    },
    {
      title: lang("Status"),
      dataIndex: "status",
      key: "status",
   
      render: (_, { status }) => {
        return status ? <span className="cap"><Tag color={status === "Draft" ? "processing" : "success"}>{status}</Tag></span> : "-";
      },
    },
    {
      title: lang("Action"),
      fixed: "right",
      key: "action",
      render: (_, record) => {
        return (
          <div div className="d-flex justify-contenbt-start">
           
              <>
              {record.status === "Draft" && 
               <Tooltip title={lang("Delete")} color={"purple"} key={lang("Delete")}>
               <Button
                 title={lang("Delete")}
                 className="btnStyle deleteDangerbtn"
                 onClick={(e) => {
                   setSelectedAddBanner(record);
                   setShowDelete(true);
                 }}
               >
                 <img src={deleteWhiteIcon} />
               </Button>
             </Tooltip>}
             
              </>
        
         
          </div>
        );
      },
    },
 
  ];

  const onDelete = (record) => {
    request({
      url: apiPath.notification + "/scheduler/" + record?._id,
      method: "DELETE",
      onSuccess: (data) => {
        setLoading(false);
        ShowToast(data.message, Severty.SUCCESS);
        setRefresh((prev) => !prev);
      },
      onError: (error) => {
        setLoading(false);
        ShowToast(error, Severty.ERROR);
      },
    });
  };

  const fetchData = (sorter) => {
    request({
      url:
        `${apiPath.notification}/schedule-notification/${data?._id}` + 
        `?status=${""}&page=${pagination ? pagination.current : 1}&pageSize=${
          pagination && pagination?.total ? pagination?.total : 10
        }&search=${""}`,
      method: "GET",
      onSuccess: (data) => {
        setList(data.data);
      },
      onError: (err) => {
        console.log(err);
      },
    });
  };

  useEffect(() => {
    fetchData(pagination);
  }, [refresh]);

  const handleChange = (pagination, filters, sorter) => {
    const { field, order } = sorter;
    let query = undefined;
    if (field && order) {
      query = `${field}=${order}`;
      console.log(query);
    }
    fetchData(pagination, filters, query);
  };

  return (
    <Modal
      width={750}
      open={show}
      maskClosable={false}
      okText={false}
      cancelText={lang("Back")}
      onCancel={hide}
      okButtonProps={{
        form: "create",
        htmlType: "submit",
        loading: loading,
      }}
      className="tab_modal"
    >
 <SectionWrapper
        cardHeading={lang("Scheduler Push Notifications")}
      
      >
        <div className="table-responsive customPagination">
          <Table
            loading={loading}
            columns={columns}
            dataSource={list}
            pagination={{
              defaultPageSize: 10,
              responsive: true,
              total: pagination.total,
              showSizeChanger: true,
              showQuickJumper: true,
              pageSizeOptions: ["10", "20", "30", "50"],
            }}
            onChange={handleChange}
            className="ant-border-space"
          />
        </div>
      </SectionWrapper>
      {showDelete && (
        <DeleteModal
          title={lang("Delete Notification Scheduler")}
          subtitle={lang(`Are you sure you want to Delete this notification?`)}
          show={showDelete}
          hide={() => {
            setShowDelete(false);
            setSelectedAddBanner();
          }}
          onOk={() => onDelete(selectedAddBanner)}
        />
      )}
    </Modal>
  );
};

export default ViewNotificationModal;
